module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/user-39a31b0fda3f6d0d9998f93cd6357590.svg";